// extracted by mini-css-extract-plugin
export default {"page":"o0-z","cartModal":"p0-z","checkout":"q0-z","placeholder":"r0-z","account":"s0-z"};